import { select } from '@angular-redux/store';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, AsyncValidatorWExt, AuthenticationService, ConfirmModalService, ModalService, ProxyService, ValidationService } from '@app/core/services';
import { LocalSignupFormModel } from '@app/shared/models/register-models';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { Observable } from 'rxjs';
import * as Store from '@core/redux/stores';
import { CustomerInfo } from '@core/redux/stores';
import { Constants } from '@core/constants/core.constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GuestSignupTermsConditionsComponent } from '../guest-signup-terms-conditions';

@Component({
  selector: "app-guest-signup",
  templateUrl: "./guest-signup.component.html",
  styleUrls: ["./guest-signup.component.less"],
  providers: [AlertService],
})
export class GuestSignupComponent implements OnInit {
  signupForm: UntypedFormGroup;
  guestUser: any;
  userEmail: string;
  showErrorMessage: boolean;
  loading: boolean;
  public order: Store.UserOrderInfo;
  tncUser:any;
  @select((appState) => appState.submittedOrder)
  submittedOrder: Observable<Store.UserOrderInfo>;
 
  // {firstname:string,lastname:string,email:string,phonenumber:string}

  constructor(
    private fBuilder: UntypedFormBuilder,
    private proxy: ProxyService,
    private registrationService: AuthenticationService,
    private modalService: ModalService,
    private confirmModalService: ConfirmModalService,
    public alertService: AlertService,
    private ngModalService: NgbModal
  ) {
    this.registrationService.setAlertService(this.alertService);
    this.loading = false;
    this.createSignupForm();

    this.submittedOrder.subscribe((succ) => {
      this.order = succ as Store.UserOrderInfo;
      if (this.order?.customerInfo) {
        const customerInfo = this.order.customerInfo as any;
        this.signupForm.patchValue({
          email: customerInfo.Email || customerInfo.email,
          firstname: customerInfo.FirstName || customerInfo.firstName,
          lastname: customerInfo.LastName || customerInfo.lastName
        });
      }
    });

    this.modalService.modalOptions.subscribe((succ:any)=>
    {
      this.tncUser = succ;
    if(this.tncUser)
    {
       this.signupForm.patchValue({
         email:this.tncUser.email,
         firstname:this.tncUser.firstname,
         lastname:this.tncUser.lastname,
         zipcode:this.tncUser.zipcode,
         passwords:{
          password:this.tncUser.passwords.password,
          confPw:this.tncUser.passwords.confPw
         },
         addToEmail:this.tncUser.addToEmail,
         termncondn:this.tncUser.termncondn

       })
    }
    })
  }

  ngOnInit(): void {
   
  }
  createSignupForm() {
    this.signupForm = this.fBuilder.group({
      email: [
        null,
        [Validators.required],
        [
          AsyncValidatorWExt.debounce(
            ValidationService.asyncEmailValidator,
            800
          ),
        ],
      ],
      firstname: new UntypedFormControl(null, [
        Validators.required,
        ValidationService.firstNameLastNameValidator,
      ]),
      lastname: new UntypedFormControl(null, [
        Validators.required,
        ValidationService.firstNameLastNameValidator,
      ]),
      zipcode: new UntypedFormControl(null, [
        Validators.required,
        ValidationService.validateCardZip,
      ]),
      passwords: this.fBuilder.group(
        {
          password: new UntypedFormControl(null, [
            Validators.required,
            ValidationService.passwordValidator,
          ]),
          confPw: new UntypedFormControl(null, [Validators.required]),
        },
        { validator: ValidationService.passwordMatch }
      ),
      addToEmail: new UntypedFormControl(null),
      termncondn: new UntypedFormControl(null, [Validators.required,Validators.requiredTrue]),
    });
  }

  onSubmit() {
    let res = this.formatSignupObj();
    this.loading = true;
    const formModel = <LocalSignupFormModel>this.signupForm.value;
    sessionStorage.setItem("signUpForm", JSON.stringify(this.signupForm.value));
    this.validateCustomerInfo(res);
    this.registrationService.checkifAccountSub.subscribe((succ) => {
      this.showErrorMessage = true;
    });
    this.registrationService.guestSignUpSub.next(false);
    this.registrationService.guestSignUpSub.subscribe((succ) => {
      if (succ) {
        this.showErrorMessage = false;
        this.loading =false;
        this.signupForm.clearValidators();
        this.signupForm.clearAsyncValidators();
        this.signupForm.reset();
        this.modalService.hideModal();
      }
      else {
        this.loading =  false;
      }
    });
  }

  validateCustomerInfo(formModel) {
    this.loading=true;
    const parameters = [
      {
        Name: "firstname",
        Value: this.signupForm.value.firstname,
      },
      {
        Name: "lastname",
        Value: this.signupForm.value.lastname,
      },
      {
        Name: "zipcode",
        Value: this.signupForm.value.zipcode,
      },
      {
        Name: "email",
        Value: this.signupForm.value.email,
      },
    ];
    this.proxy.httpPost(ApiRoutes.VALIDATE_CUSTOMERS, parameters).subscribe(
        (success) => {
        this.loading = true;
         this.registrationService.setGuestSignup(formModel, false);
      },
      (err) => {
        this.loading = false;
        if (err.error && err.error) {
          if (err.error instanceof Array) {
            const messg = [];
            err.error.forEach((item) => {
              messg.push("<p>" + item.message + "</p>");
            });
            const logmsg = messg.join(" ");
            this.confirmModalService.show(
              "",
              "Error!",
              logmsg,
              "",
              "",
              "OK, Got It",
              true,
              ""
            );
          } else {
            this.alertService.error(err.error.message);
          }
        }
      }
    );
  }

  showTerms() {
    this.modalService.setModalSelector(
      "guest-signup-terms-conditions",
     this.signupForm.value
    );
     this.modalService.showModal(false);
  }

  formatSignupObj(): LocalSignupFormModel {
    const customerInfo = this.order?.customerInfo as any;
    return {
      firstname: this.signupForm.controls.firstname.value,
      lastname: this.signupForm.controls.lastname.value,
      email: this.signupForm.controls.email.value,
      zipcode: this.signupForm.controls.zipcode.value,
      passwords: {
        password:
          this.signupForm["controls"].passwords["controls"].password.value,
          confPw: this.signupForm["controls"].passwords["controls"].confPw.value,
      },
      addToEmail: this.signupForm.controls.addToEmail.value,
      phonenumber: customerInfo.phoneNumber ?? customerInfo.PhoneNumber ?? '',

      orderId: this.order?.orderNumber,
      guestUserGuid: this.order?.guid,
      orderIdentifiers: [
        {
          orderId: this.order?.orderNumber,
          userIdOrGuid: this.order?.guid,
        },
      ],
    };
  }
}
